var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "66px",
    viewBox: "0 0 66 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aankomst/vertrek-scherm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Start",
    transform: "translate(-467.000000, -310.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login",
    transform: "translate(500.000000, 343.000000) rotate(-180.000000) translate(-500.000000, -343.000000) translate(467.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "30.4250628 44.5151652 35.0615201 49.1764706 50.4705882 33.6189926 35.0582969 18.1176471 30.4284394 22.7888491 37.9494829 30.3498625 0 30.3498625 0 36.9476571 37.9233905 36.9476571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8836253,0 C18.0840672,0 5.52637711,9.73171521 1.29411765,23.0999845 L8.33794854,23.0999845 C12.2820964,13.4409726 21.7897779,6.60006188 32.8836253,6.60006188 C47.491316,6.60006188 59.376694,18.4437288 59.376694,33 C59.376694,47.5562712 47.491316,59.4000928 32.8836253,59.4000928 C21.7896227,59.4000928 12.2819412,52.5624306 8.34120842,42.9000155 L1.29411765,42.9000155 C5.52311723,56.2716879 18.0808073,66 32.8837805,66 C51.1440925,66 66,51.1962284 66,33 C66,14.8037716 51.1439372,0 32.8836253,0 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.eab87463575eb24320c0eb9becd44fb5.svg";
export { ForwardRef as ReactComponent };